type UploadMeshIndexEntry = {
  fileName: string;
  meshStem: string;
  extension: "obj" | "stl" | "dae";
  bytes: number;
  indexedAt: string;
};

const uploadMeshIndex = new Map<string, UploadMeshIndexEntry>();

function toStem(fileName: string): string {
  return fileName.replace(/^.*[\\/]/, "").replace(/\.(obj|stl|dae)$/i, "");
}

export function getUploadMeshIndexEntries(): UploadMeshIndexEntry[] {
  return Array.from(uploadMeshIndex.values());
}

export function clearUploadMeshIndex(): void {
  uploadMeshIndex.clear();
}

export function indexUploadedMeshFiles(files: File[]): void {
  if (!Array.isArray(files) || files.length === 0) return;
  const now = new Date().toISOString();
  files.forEach((file) => {
    const lower = file.name.toLowerCase();
    if (!lower.endsWith(".obj") && !lower.endsWith(".stl") && !lower.endsWith(".dae")) return;
    const extension = lower.endsWith(".obj") ? "obj" : lower.endsWith(".stl") ? "stl" : "dae";
    const meshStem = toStem(file.name);
    uploadMeshIndex.set(file.name, {
      fileName: file.name,
      meshStem,
      extension,
      bytes: file.size,
      indexedAt: now,
    });
  });
}
